import React from 'react';
import { useAuth } from './useAuth';
import permissions from '../constants/permissions';

export const usePermissions = () => {
  const { isAuthenticated } = useAuth();
  const roles = JSON.parse(localStorage.getItem('roles'));

  const can = permission => {
    if (!isAuthenticated) {
      return false;
    }
    if (roles && roles.some(role => permissions(role)[permission])) {
      return true;
    }
  };

  const role = roleValue => roles.include(roleValue);

  return {
    role,
    can,
  };
};

export function Gate({ permission, fallback, children }) {
  const { can } = usePermissions();

  return <>{can(permission) ? children : fallback}</>;
}
